import { render, staticRenderFns } from "./liste_commande.vue?vue&type=template&id=2d15b668&scoped=true&"
import script from "./liste_commande.vue?vue&type=script&lang=js&"
export * from "./liste_commande.vue?vue&type=script&lang=js&"
import style0 from "./liste_commande.vue?vue&type=style&index=0&id=2d15b668&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d15b668",
  null
  
)

export default component.exports